function devtricker_dom_restoreOriginalSocialLoginButtons() {

    const buttons = document.querySelectorAll('.social-login-button');

    buttons.forEach(button => {

        const originalContent = g_devtricker_socialLogin_originalButtonValuesInnerHTML[button.id];

        button.innerHTML = originalContent;
        button.classList.add('d-flex');
        button.classList.add('align-items-center');
    });
}

function devtricker_dom_set_changeContinueWithLoginSocialButtonToLoading(button) {
    button.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${g_devtricker_i18n.loading}`;
    button.classList.remove('d-flex', 'align-items-center');
}

function devtricker_dom_get_loginButton(buttonId) {
    return document.getElementById(buttonId);
}